import React from "react";
import quoteIcon from "../assets/Qoute.png";
import director from "../assets/Director.jpeg";

const QuoteCard = () => {
  return (
    <div className="quote-container">
      <div className="quote-card">
        <div className="image-section">
          <img
            src={director}
            alt="Aarthi Kanodia - Director, Realflame"
            className="building-image"
          />
        </div>

        <div className="content-section">
          <div className="quote-icon">
            <img src={quoteIcon} alt="Quote icon" className="quote-image" />
          </div>

          <div className="author-section">
            <div className="author-name">Aarthi Kanodia</div>
            <div className="author-title">Director, Realflame</div>
          </div>
          
          <div className="quote-text">
            Efficient cooking appliances play a crucial role in reducing fuel
            consumption and overall energy costs, functioning as a practical
            subsidy for households and businesses. At Realflame, we are
            dedicated to delivering high-efficiency stoves and burners that
            promote cleaner, safer, and more affordable cooking while supporting
            long-term sustainability and energy savings.
          </div>
        </div>
      </div>

      <style jsx>{`
        .quote-container {
          width: 100%;
          max-width: 1200px;
          margin: 64px auto;
        }

        .quote-card {
          display: flex;
          gap: 40px;
          background: var(--color-white);
          width: 100%;
          align-items: stretch;
        }

        .image-section {
          flex: 1;
          min-height: 480px;
        }

        .building-image {
          width: 100%;
          height: 100%;
          min-height: 480px;
          max-height: 540px;
          object-fit: cover;
          object-position: top center;
          display: block;
          border-radius: 4px;
        }

        .content-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0;
        }

        .quote-icon {
          margin-bottom: var(--spacing-3);
        }

        .quote-image {
          width: 115px;
          height: 80px;
          display: block;
        }

        .quote-text {
          font-family: var(--font-family-secondary);
          font-size: var(--font-size-2);
          color: var(--color-black);
          margin-bottom: var(--spacing-4);
          font-style: italic;
          line-height: 1.6;
        }

        .author-name {
          font-family: var(--font-family-primary);
          font-size: var(--font-size-4);
          font-weight: 600;
          color: var(--color-1);
          margin-bottom: 4px;
        }

        .author-title {
          font-family: var(--font-family-secondary);
          font-size: var(--font-size-3);
          font-weight: 550;
          color: var(--color-black);
        }

        @media (max-width: 768px) {
          .quote-card {
            flex-direction: column;
            padding: 0 24px;
            gap: 24px;
          }

          .quote-container {
            padding: 0;
            margin-bottom: 32px;
          }

          .image-section {
            width: 100%;
            height: 420px;
            min-height: 420px;
          }

          .building-image {
            width: 100%;
            height: 420px;
            min-height: 420px;
            max-height: 420px;
            object-fit: cover;
            object-position: top center;
          }

          .content-section {
            padding: 0;
          }

          .quote-icon {
            margin-top: var(--spacing-4);
            margin-bottom: var(--spacing-3);
          }
        }
      `}</style>
    </div>
  );
};

export default QuoteCard;
